//let server_url = "https://services.daltholdings.com/";
let server_url = "https://dalt.onrender.com/";

if (process.env.NODE_ENV === 'development') {
    server_url = "http://localhost:8000/";
}

export const SERVER_URL = server_url;
export const API_VERSION = "v1";
export const API_ENDPOINT = SERVER_URL + "api/" + API_VERSION;